import * as React from 'react';
import { DateInput } from '@progress/kendo-react-dateinputs';
import { PureComponent } from '../../../../dispatcher/modules';
import classNames from 'classnames';
import { Label } from '@progress/kendo-react-labels';
import { CUSTOM_DATE_INPUT_PROPS } from './Types';

class CustomDateInput extends PureComponent<CUSTOM_DATE_INPUT_PROPS, {}> {
  static defaultProps = {
    size: 'medium'
  }

  render() {
    const {
      size,
      value,
      valid,
      disabled,
      id,
      label
    } = this.props;

    const fieldCls = classNames(
      'tp-50',
      {
        'k-medium': size === 'medium',
        'k-state-empty': !value,
        'k-state-invalid': !valid,
        'k-state-disabled': disabled
      }
    );

    return (
      <div className={`${fieldCls}`} >
        <Label editorId={id}>{label}</Label>
        <div
          className={'tp-daterange-input'}
        >
          <DateInput
            {...this.props}
            label={undefined}
          />
        </div>
      </div>
    );
  }
}
export default CustomDateInput;
